//@ts-nocheck
import React, {
  Fragment,
  useEffect,
  useRef,
  useState,
  useCallback,
} from "react";
import { Toaster, toast } from "sonner";

import { Dialog, Transition } from "@headlessui/react";
import { useDispatch } from "react-redux";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { RootState } from "../../../app/store";
import {
  baseDetailsData,
  updateBase,
  uploadBaseCover,
  uploadBaseLogo,
} from "../../base/baseSlice";
import { UpdateBasePayload } from "../../base/baseTypes";
import { Menu } from "@headlessui/react";
import { MenuItem, MenuItems, MenuButton } from "@headlessui/react";
import { CustomCheckIcon } from "../../../components/icons";
import { SketchPicker } from "react-color";
import { UserDetails } from "../../auth/authTypes";
import Cropper from "react-easy-crop";
import { getCroppedImg } from "../profileSetting/canvasUtils";

interface BaseDetailsProps {
  userDetails: UserDetails;
}

const colorList = [
  { name: "#69737d" },
  { name: "#c32c68" },
  { name: "#9051b2" },
  { name: "#6a56df" },
  { name: "#2c6cd5" },
  { name: "#318727" },
  { name: "#aa5c00" },
  { name: "#c53c00" },
  { name: "#c53635" },
  { name: "#20808D" },
];

const BaseDetails: React.FC<BaseDetailsProps> = React.memo(
  ({ userDetails }) => {
    const [name, setName] = useState("");
    const [color, setColor] = useState("#808080");
    const [data, setData] = useState<any>();
    const baseInfo = useAppSelector(
      (state: RootState) => state.base.baseDetails,
    );
    const [logoUrl, setLogoUrl] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [logoUrlCover, setLogoUrlCover] = useState<string>("");
    const [loadingCover, setLoadingCover] = useState<boolean>(false);
    const [description, setDescription] = useState("");
    const dispatch = useAppDispatch();
    const baseIdString =
      localStorage.getItem("UserBaseId") ||
      localStorage.getItem("createBaseId");
    const baseId = baseIdString ? JSON.parse(baseIdString) : null;
    const [baseLoading, setBaseLoading] = useState(false);
    const [showColorPicker, setShowColorPicker] = useState(false);
    const [desEditable, setDesEditable] = useState(false);

    // Cropper States
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
    const [showCropModal, setShowCropModal] = useState(false);
    const [cropSrc, setCropSrc] = useState<string | null>(null);

    const [cropCover, setCropCover] = useState({ x: 0, y: 0 });
    const [zoomCover, setZoomCover] = useState(1);
    const [croppedAreaPixelsCover, setCroppedAreaPixelsCover] = useState(null);
    const [showCropModalCover, setShowCropModalCover] = useState(false);
    const [cropSrcCover, setCropSrcCover] = useState<string | null>(null);

    const [logoLoading, setLogoLoading] = useState(true);
    const [coverLoading, setCoverLoading] = useState(true);

    const onCropComplete = useCallback((_, pixels) => {
      setCroppedAreaPixels(pixels);
    }, []);

    const onCropCompleteCover = useCallback((_, pixels) => {
      setCroppedAreaPixelsCover(pixels);
    }, []);

    useEffect(() => {
      const baseInfoString = localStorage.getItem("baseDetails");
      if (baseInfoString) {
        const baseInfo = JSON.parse(baseInfoString);
        setName(baseInfo?.data?.base?.name);
      } else {
        setName(baseInfo?.name);
      }
    }, [baseInfo]);

    useEffect(() => {
      const baseInfoString = localStorage.getItem("baseDetails");
      if (baseInfoString) {
        const baseInfo = JSON.parse(baseInfoString);
        setDescription(baseInfo?.data?.base?.description);
      } else {
        setDescription(baseInfo?.description);
      }
    }, [baseInfo]);

    useEffect(() => {
      if (baseId) {
        dispatch(baseDetailsData(baseId));
      }
    }, [baseId, dispatch]);

    useEffect(() => {
      const baseInfoString = localStorage.getItem("baseDetails");
      if (baseInfoString) {
        const baseInfo = JSON.parse(baseInfoString);
        if (baseInfo?.data?.base?.logo) {
          setLogoLoading(true);
          const newLogoUrl = `${process.env.REACT_APP_API_BASE_URL}/${baseInfo?.data?.base?.logo}`;
          setLogoUrl(newLogoUrl);

          // Preload the image
          const img = new Image();
          img.onload = () => {
            setLogoLoading(false);
          };
          img.onerror = () => {
            setLogoLoading(false);
            setLogoUrl("");
          };
          img.src = newLogoUrl;
        } else {
          setLogoUrl("");
          setLogoLoading(false);
        }
      } else {
        setLogoUrl("");
        setLogoLoading(false);
      }
    }, []);

    useEffect(() => {
      const baseInfoString = localStorage.getItem("baseDetails");
      if (baseInfoString) {
        const baseInfo = JSON.parse(baseInfoString);
        if (baseInfo?.data?.base?.cover_image) {
          setCoverLoading(true);
          const newCoverUrl = `${process.env.REACT_APP_API_BASE_URL}/${baseInfo?.data?.base?.cover_image}`;
          setLogoUrlCover(newCoverUrl);

          // Preload the image
          const img = new Image();
          img.onload = () => {
            setCoverLoading(false);
          };
          img.onerror = () => {
            setCoverLoading(false);
            setLogoUrlCover("");
          };
          img.src = newCoverUrl;
        } else {
          setLogoUrlCover("");
          setCoverLoading(false);
        }
      } else {
        setLogoUrlCover("");
        setCoverLoading(false);
      }
    }, []);

    useEffect(() => {
      const baseInfoString = localStorage.getItem("baseDetails");
      if (baseInfoString) {
        const baseInfo = JSON.parse(baseInfoString);
        setName(baseInfo?.data?.base?.name);
        localStorage.setItem("name", baseInfo.name || "");
      }
    }, []);

    useEffect(() => {
      const baseInfoString = localStorage.getItem("baseDetails");
      if (baseInfoString) {
        const baseInfo = JSON.parse(baseInfoString);
        setColor(baseInfo?.data?.base?.primary_color);
      }
    }, []);

    const _updateHandler = async () => {
      setBaseLoading(true);
      const payload: UpdateBasePayload = {
        name,
        description,
        primary_color: color,
      };

      const userId = baseId;
      const resultAction = await dispatch(updateBase({ payload, userId }));
      setBaseLoading(false);
      if (updateBase.fulfilled.match(resultAction)) {
        localStorage.setItem(
          "baseDetails",
          JSON.stringify(resultAction.payload),
        );
        setData(resultAction.payload);
        toast.success("Base updated successfully!");
      } else {
        // Handle the error
        const errorMessage =
          (resultAction.payload as string) || "Failed to update base";
        toast.error(errorMessage);
      }
    };

    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const newName = e.target.value;
      setName(newName);
      localStorage.setItem("name", newName);
    };

    const handleDescriptionChange = (
      e: React.ChangeEvent<HTMLInputElement>,
    ) => {
      const newDescription = e.target.value;
      setDescription(newDescription);
      localStorage.setItem("base_description", newDescription);
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target.files && event.target.files[0]) {
        setCropSrc(URL.createObjectURL(event.target.files[0]));
        setShowCropModal(true);
        setZoom(1); // Reset zoom
      }
    };

    const handleFileChangeCover = (
      event: React.ChangeEvent<HTMLInputElement>,
    ) => {
      if (event.target.files && event.target.files[0]) {
        setCropSrcCover(URL.createObjectURL(event.target.files[0]));
        setShowCropModalCover(true);
        setZoomCover(1); // Reset zoom
      }
    };

    const handleCropSave = async () => {
      setLogoLoading(true);
      try {
        const croppedImageBlob = await getCroppedImg(
          cropSrc,
          croppedAreaPixels,
        );
        const croppedFile = new File([croppedImageBlob], "logo.jpeg", {
          type: "image/jpeg",
        });

        const result = await dispatch(
          uploadBaseLogo({
            payload: { image: croppedFile },
            userId: baseId,
          }),
        );

        if (uploadBaseLogo.fulfilled.match(result)) {
          toast.success("Logo updated successfully!");
          setLogoUrl(
            `${process.env.REACT_APP_API_BASE_URL}/${result.payload.data.base.logo}`,
          );
          setShowCropModal(false);
        }
      } catch (error) {
        toast.error("Upload failed");
      } finally {
        setLogoLoading(false);
      }
    };

    const handleCropSaveCover = async () => {
      setCoverLoading(true);
      try {
        const croppedImageBlob = await getCroppedImg(
          cropSrcCover,
          croppedAreaPixelsCover,
        );
        const croppedFile = new File([croppedImageBlob], "cover.jpeg", {
          type: "image/jpeg",
        });

        const result = await dispatch(
          uploadBaseCover({
            payload: { image: croppedFile },
            userId: baseId,
          }),
        );

        if (uploadBaseCover.fulfilled.match(result)) {
          toast.success("Cover updated successfully!");
          setLogoUrlCover(
            `${process.env.REACT_APP_API_BASE_URL}/${result.payload?.data?.base?.cover_image}`,
          );
          setShowCropModalCover(false);
        }
      } catch (error) {
        toast.error("Upload failed");
      } finally {
        setCoverLoading(false);
      }
    };

    const handleEnableEdit = () => {
      setDesEditable(!desEditable);
    };

    const handleNavigateToJob = () => {
      window.open(`https://jobs.teamer.app/${baseInfo?.base_slug}`, "_blank");
    };

    return (
      <>
        <main className="h-full flex">
          <div className=" w-full flex justify-center">
            <div className="w-full ">
              <div className="flex items-center justify-between gap-x-[6px]">
                <div className="flex flex-col gap-y-1 w-[90%]">
                  <h2 className="text-[20px] lg:text-[24px] font-medium leading-8 text-[#1b1b1b] tracking-[-0.01rem]">
                    Organization Details
                  </h2>
                  <p className="text-sm leading-5 text-[#5c5c5e] font-medium">
                    This information will be publicly visible on your career
                    page and job postings. Please ensure all details are
                    accurate and up-to-date.
                  </p>
                </div>
                <span
                  data-title={"click to preview profile"}
                  className="table-tooltip-list before:!bottom-[37px] before:!left-[7px] before:!text-[12px]"
                >
                  <button
                    className=" rounded-md duration-200 font-[600] text-[0.8125rem] h-[32px] w-[32px] flex items-center justify-center border border-solid border-[#e7e7e8]"
                    style={{
                      transitionProperty:
                        "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
                    }}
                    onClick={handleNavigateToJob}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      aria-hidden="true"
                      data-slot="icon"
                      className="w-[1.1em] h-[1.1em] text-[#000]"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25"
                      />
                    </svg>
                  </button>
                </span>
              </div>
              <div className="bg-[#e0e0e0] w-full h-[1px] my-8"></div>
              <div className="min-h-[172px] max-h-[172px] h-auto relative">
                <label className="h-full relative block">
                  <input
                    className="opacity-0 focus:outline-none absolute top-[118px] left-[36px] h-[70px] w-[70px] flex justify-center items-center"
                    type="file"
                    onChange={handleFileChangeCover}
                    accept="image/*"
                  />
                  {coverLoading ? (
                    <div
                      // className="flex items-center justify-center bg-[#f5f5f5] rounded-2xl h-full  w-full"
                      className="flex items-center justify-center bg-[#f5f5f5] rounded-2xl h-full min-h-[172px] max-h-[172px] w-full"
                    >
                      <div className="simple-spinner-loader">
                        <span className="!w-4 !h-4"></span>
                      </div>
                    </div>
                  ) : logoUrlCover ? (
                    <img
                      src={logoUrlCover}
                      alt="Base Logo"
                      className="h-full max-h-[172px] object-cover w-full border border-[#e0e0e0] border-solid rounded-lg cursor-move"
                      onLoad={() => setCoverLoading(false)}
                    />
                  ) : (
                    <div className="h-full w-full min-h-[172px] max-h-[172px] border-[5px] border-solid border-[#f5f5f5] rounded-2xl bg-gray-200 flex items-center justify-center">
                      <span className="text-gray-500 text-sm">No cover</span>
                    </div>
                  )}
                </label>

                <label className="flex flex-inherit h-[70px] w-[70px] z-10 absolute top-[118px] left-[36px] cursor-move">
                  <input
                    className="opacity-0 focus:outline-none cursor-move"
                    type="file"
                    onChange={handleFileChange}
                    accept="image/*"
                  />
                </label>
                <div className="absolute top-[136px] left-[36px] h-[70px] w-[70px]">
                  {logoLoading ? (
                    <div className="flex items-center justify-center bg-[#f5f5f5] rounded-2xl h-full w-full">
                      <div className="simple-spinner-loader">
                        <span className="!w-4 !h-4"></span>
                      </div>
                    </div>
                  ) : logoUrl ? (
                    <img
                      src={logoUrl}
                      alt="Base Logo"
                      className="h-full w-full border-[5px] border-solid border-[#f5f5f5]  bg-[#f5f5f5] rounded-2xl object-cover cursor-move"
                      onLoad={() => setLogoLoading(false)}
                    />
                  ) : (
                    <div className="h-full w-full border-[5px] border-solid border-[#f5f5f5] rounded-2xl bg-gray-200 flex items-center justify-center">
                      <span className="text-gray-500 text-sm">No Logo</span>
                    </div>
                  )}
                </div>
              </div>

              <div className="sm:col-span-4 mt-14 lg:mt-16">
                {/* <label htmlFor='username' className='wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5'>
                Base name
              </label> */}
                <div className="mt-[-6px] flex items-center">
                  <div className="relative w-full">
                    <input
                      id="name"
                      name="name"
                      type="name"
                      autoComplete="name"
                      // onChange={handleNameChange}
                      placeholder="Enter Name"
                      value={name}
                      className="flex w-full grow border-none !outline-none cursor-default font-medium
                     px-4 py-2 pl-0 text-base leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)] transition-colors duration-100 placeholder:text-surface-500 outline-indigo-600
                    focus:outline focus:outline-2 focus:-outline-offset-2 bg-background text-text-100 hover:border-[#a9a9bc] dark:hover:border-surface-200
                      border-[#d1d1db] dark:border-surface-100 focus:outline-indigo-600 h-[36px] rounded-[0.375rem]"
                    />
                  </div>
                </div>
              </div>
              <div className="sm:col-span-4 mt-4 lg:mt-4">
                <label
                  htmlFor="username"
                  className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
                >
                  Base color
                </label>
                <div className="mt-[6px] flex items-center">
                  <div className="relative w-full">
                    <Menu
                      as="div"
                      className="absolute left-0 top-1/2 -translate-y-1/2 z-10"
                    >
                      <Menu.Button className="flex items-center justify-center h-[36px] w-20 rounded-l-md dark:hover:border-surface-200">
                        <div
                          style={{ background: color }}
                          className={`w-full h-full rounded-l-md`}
                        />
                      </Menu.Button>
                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                      >
                        <Menu.Items className="absolute flex flex-wrap left-0 top-8 z-10 mt-2.5 w-64 p-2 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none">
                          <div className="flex flex-wrap">
                            {colorList.map((value: any, index) => {
                              return (
                                <div
                                  onClick={() => setColor(value.name)}
                                  key={index}
                                  style={{ background: value.name }}
                                  className={`flex h-6 w-6 border rounded-full m-2 justify-center items-center`}
                                >
                                  {color === value.name ? (
                                    <CustomCheckIcon />
                                  ) : null}
                                </div>
                              );
                            })}
                            <div
                              onClick={() =>
                                setShowColorPicker(!showColorPicker)
                              }
                              className="cursor-pointer flex items-center"
                            >
                              <span className="text-sm border-gray-200 border-solid border rounded-md px-2 py-1">
                                Custom
                              </span>
                            </div>
                          </div>

                          {showColorPicker && (
                            <div className="mt-4">
                              <SketchPicker
                                color={
                                  typeof color === "string" &&
                                  color.startsWith("#")
                                    ? color
                                    : "#808080"
                                } // Default to gray if color is not in hex format
                                onChangeComplete={(color) =>
                                  setColor(color.hex)
                                }
                              />
                            </div>
                          )}
                        </Menu.Items>
                      </Transition>
                    </Menu>
                    <div
                      className="flex items-center w-full grow border px-4 py-2 pl-[100px] text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)] transition-colors duration-100 placeholder:text-surface-500 outline-indigo-600
                    focus:outline focus:outline-2 focus:-outline-offset-2 bg-background text-text-100 hover:border-[#a9a9bc] dark:hover:border-surface-200
                      border-[#d1d1db] dark:border-surface-100 focus:outline-indigo-600 h-[36px] rounded-[0.375rem]"
                    >
                      {"{"}
                      {color}
                      {"}"}
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className='sm:col-span-4 mt-5'> */}
              <div className="flex justify-between items-center mt-7">
                <label
                  htmlFor="description"
                  className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
                >
                  Base Description
                </label>
                <button onClick={handleEnableEdit}>Edit</button>
              </div>
              {!desEditable && (
                <div
                  className="flex mt-[6px] grow rounded-lg border border-[#e5e7eb] bg-background px-4 py-[8px] text-sm leading-6 h-[150px]
    shadow-wg-xs transition-colors duration-100 w-full text-surface-900 
    hover:border-surface-300 dark:hover:border-surface-200 border-surface-200 
    dark:border-surface-100 focus:outline-indigo-600   
    overflow-y-auto whitespace-pre-wrap break-words"
                >
                  {description || (
                    <span className="text-gray-400 italic">
                      No description provided.
                    </span>
                  )}
                </div>
              )}
              {desEditable && (
                <div className="mt-[6px]">
                  <textarea
                    id="description"
                    name="description"
                    type="description"
                    rows={10}
                    maxLength={1500}
                    autoComplete="description"
                    onChange={handleDescriptionChange}
                    placeholder="Enter Description"
                    value={description}
                    className="flex grow rounded-lg border border-[#e5e7eb] bg-background px-4 py-[5px] text-sm leading-6
             shadow-wg-xs transition-colors duration-100 placeholder:text-surface-500 outline-primary focus:outline
              focus:outline-2 focus:-outline-offset-2 w-full text-surface-900 hover:border-surface-300
             dark:hover:border-surface-200 border-surface-200 dark:border-surface-100 focus:outline-indigo-600   
            "
                  />
                </div>
              )}

              <div className="mt-12 flex items-center justify-end">
                <button
                  onClick={_updateHandler}
                  type="submit"
                  style={{
                    backgroundColor: color,
                    // Adjust hover and focus states dynamically
                    "--hover-color": `${color}80`, // 50% opacity for hover
                    "--focus-color": `${color}40`, // 25% opacity for focus
                  }}
                  className="group inline-flex shrink-0 w-full select-none  justify-center leading-6 transition-colors
              duration-100 wg-antialiased focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none gap-0 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] rounded-md text-white outline-indigo-600
              disabled:opacity-50 hover:bg-[var(--hover-color)] focus-visible:bg-[var(--focus-color)]"
                >
                  {baseLoading ? (
                    <div className="flex items-center  gap-[6px]">
                      Update
                      <div className="simple-spinner">
                        <span></span>
                      </div>
                    </div>
                  ) : (
                    "Update"
                  )}
                </button>
              </div>
            </div>
          </div>
        </main>

        <Transition.Root show={showCropModal} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-50"
            onClose={() => setShowCropModal(false)}
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            <div className="fixed inset-0 z-10 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4">
                <Dialog.Panel className="relative transform rounded-lg bg-white p-6 shadow-xl transition-all sm:w-full sm:max-w-lg">
                  <div className="relative h-[300px] w-full bg-gray-200 rounded-md overflow-hidden">
                    <Cropper
                      image={cropSrc}
                      crop={crop}
                      zoom={zoom}
                      aspect={1}
                      onCropChange={setCrop}
                      onCropComplete={onCropComplete}
                      onZoomChange={setZoom}
                    />
                  </div>
                  <div className="mt-4">
                    <label className="text-xs text-gray-500">Zoom</label>
                    <input
                      type="range"
                      value={zoom}
                      min={1}
                      max={3}
                      step={0.1}
                      onChange={(e) => setZoom(e.target.value)}
                      className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-indigo-600"
                    />
                  </div>

                  <div className="flex justify-end mt-5 gap-3">
                    <button
                      onClick={() => setShowCropModal(false)}
                      className="inline-flex justify-center rounded-md bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleCropSave}
                      disabled={logoLoading}
                      className="inline-flex justify-center rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 disabled:opacity-50"
                    >
                      {logoLoading ? (
                        <div className="flex items-center gap-2">
                          Saving...{" "}
                          <div className="simple-spinner border-white" />
                        </div>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </Dialog.Panel>
              </div>
            </div>
          </Dialog>
        </Transition.Root>

        {/* 7. Updated Cover Modal */}
        <Transition.Root show={showCropModalCover} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-50"
            onClose={() => setShowCropModalCover(false)}
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            <div className="fixed inset-0 z-10 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4">
                <Dialog.Panel className="relative transform rounded-lg bg-white p-6 shadow-xl transition-all sm:w-full sm:max-w-2xl">
                  <div className="relative h-[350px] w-full bg-gray-200 rounded-md overflow-hidden">
                    <Cropper
                      image={cropSrcCover}
                      crop={cropCover}
                      zoom={zoomCover}
                      aspect={7 / 2} // Maintain cover aspect ratio
                      onCropChange={setCropCover}
                      onCropComplete={onCropCompleteCover}
                      onZoomChange={setZoomCover}
                    />
                  </div>
                  <div className="mt-4">
                    <label className="text-xs text-gray-500">Zoom</label>
                    <input
                      type="range"
                      value={zoomCover}
                      min={1}
                      max={3}
                      step={0.1}
                      onChange={(e) => setZoomCover(e.target.value)}
                      className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-indigo-600"
                    />
                  </div>
                  <div className="flex justify-end mt-5 gap-3">
                    <button
                      onClick={() => setShowCropModalCover(false)}
                      className="inline-flex justify-center rounded-md bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleCropSaveCover}
                      disabled={coverLoading}
                      className="inline-flex justify-center rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 disabled:opacity-50"
                    >
                      {coverLoading ? (
                        <div className="flex items-center gap-2">
                          Saving...{" "}
                          <div className="simple-spinner border-white" />
                        </div>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </Dialog.Panel>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
      </>
    );
  },
);

export default BaseDetails;
